angular.module('ui.order.orderItemsGridRouteContainer', [])

    .config(function ($stateProvider) {
        $stateProvider.state('client.orders', {
            url: '/orders/:step?search&exact&filter',
            templateUrl: 'app/ui/order/orderItemsGridView/orderItemsGridRouteContainer/orderItemsGridRouteContainer.html',
            data: {pageTitle: 'OrderManager: Orders'},
            controller: 'OrderItemsGridRouteContainerController',
            controllerAs: 'OrderItemsGridRouteContainerController',
            params: { step: 'all-open', search: null, exact: false, filter: null} // to silently pass parameters to state
        });
    })

    .controller('OrderItemsGridRouteContainerController', function ($q, $rootScope, $scope, $stateParams, orderItemsGridSharedSettings, customResourceResolver) {

        //See if we need set search string onto grid shared settings
        if ($stateParams.search && $stateParams.search.length > 0) {
            orderItemsGridSharedSettings.setTextSearch($stateParams.search, $stateParams.exact === 'true' || $stateParams.exact === true ? true : false);
        } else {
            orderItemsGridSharedSettings.setTextSearch('', false);
        }

        //See if we have been requested for a custom filter view or just a regular particular 'Step' view
        if ($stateParams.step === 'filtered') {
            //To indicate to orderItemsGridView that we want to work in 'all-open' mode, not exact 'step' view
            orderItemsGridSharedSettings.setStepFilter('all-open');

            if ($stateParams.filter && $stateParams.filter.length > 0) {
                //Get custom filter config from customisation config as it was specified via state param value
                customResourceResolver.resolveConfig('om-stat-custom-order-states', [], {})
                    .then(function(customFilters) {
                        if (customFilters) {
                            var customFilter = customFilters.find(function(f) {
                                return f.name === $stateParams.filter;
                            });
                            if (customFilter) {
                                //And set onto shared settings so gridDataProvider will be able to get the OMQL query 
                                //from orderItemsGridSharedSettings later to fetch order items from server
                                orderItemsGridSharedSettings.setCustomFilter(customFilter);
                            } else {
                                orderItemsGridSharedSettings.setCustomFilter(null); //we want to reset the custom filter then anyway
                            }
                        }
                    });
            }

        } else {
            //Set particular 'Step' filter to indicate we need a regular 'Step' view corresponding particular OrderManager workflow 'Step'
            //to render order items sitting on that workflow step
            orderItemsGridSharedSettings.setStepFilter($stateParams.step);
            orderItemsGridSharedSettings.setCustomFilter(null);
        }

    })

;
